import { render } from "./PatchAdminModal.vue?vue&type=template&id=0a8edeaa"
import script from "./PatchAdminModal.vue?vue&type=script&lang=js"
export * from "./PatchAdminModal.vue?vue&type=script&lang=js"

import "./PatchAdminModal.vue?vue&type=style&index=0&id=0a8edeaa&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__